/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

export default {
  saveList (state, categories) {
    state.list = categories
  },
  saveRoot (state, category) {
    state.root = category
  },
  saveFlatted (state, flatted) {
    state.flatted = flatted
  },
  setCurrent (state, currentCategory) {
    state.current = currentCategory
  },
  setCategoryId (state, categoryId) {
    state.categoryId = categoryId
  },
  setMetaData (state, category) {
    state.metaData = category
  }
}
